import React from 'react';
import roundLogo from '../../assets/images/round-logo.png';
import { FaInstagram, FaFacebookF, FaYoutube, FaTwitter } from 'react-icons/fa';

const Footer = ({ openContactModal }) => {
  const handleContactClick = (e) => {
    e.preventDefault();
    openContactModal();
  };
  
  return (
    <footer className="footer">
      <div className="footer-content">
          <div className="footer-logo">
            <img src={roundLogo} alt="SkillRaiz Logo" />
          </div>
          <div className="footer-description">
            <p>
              SkillRaiz is a next-gen eLearning platform dedicated to empowering tech enthusiasts with industry-ready
              skills in AWS, DevOps, and Cloud Computing. We focus on hands-on training, real-world projects, and
              expert-led sessions that make you job-ready in record time.
            </p>
          </div>
      </div>
      <div className="footer-link">
        <div className="footer-page">
         <nav className="footer-nav">
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#concepts">Concepts</a></li>
              <li><a href="#courses">Courses</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#contact" onClick={handleContactClick}>Contact</a></li>
            </ul>
          </nav>
        </div>

        <div className="footer-social">
          <a href="https://x.com/skillraiz?t=yk02ZThKmlqtIN_euLb4Qg&s=08" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <FaTwitter />
          </a>
          <a href="https://www.instagram.com/skillraiz/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://www.youtube.com/@raghavenderraoKulkarni" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <FaYoutube />
          </a>
          <a href="https://www.facebook.com/people/SkillRaiz-Aws-DevOps/pfbid034RYqYar7NGJgBgK8Vu72AniM8jhFJMYgLouucwbeULrESm6dSqxWvYiYkpxgyAf1l/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 